import { useEffect } from "react";
import {useDrag} from "react-dnd";
import pageBuilderStore from "../../../stores/pageBuilderStore";
import blocksManager from "../../../stores/blocks-manager";
import {Minus, Heading1, Type, Image, RectangleHorizontal, Columns, Images, Play, Share2, Code} from "lucide-react";

export function DraggableColumns() {
	const [{isDragging}, drag] = useDrag(() => ({
		type: 'CONTENT_BLOCKS',
		item: {blockType: 'COLUMNS', label: 'Columns'},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	}));

	useEffect(() => {
		blocksManager.setIsDraggingBlock(isDragging); // Or isBlockDragging
	}, [isDragging]);
	
	return (
		<div
			ref={drag}
			className={`flex flex-col items-center p-3 border border-gray-200 rounded cursor-pointer hover:bg-gray-50 hover:border-blue-300 transition-colors ${
				isDragging ? 'opacity-50' : ''
			}`}
		>
			<Columns size={24} className="text-gray-600 mb-2" />
			<span className="text-xs text-center text-gray-700">Columns</span>
		</div>
	);
}

export function DraggableButtons() {
	const [{isDragging}, drag] = useDrag(() => ({
		type: 'CONTENT_BLOCKS',
		item: {blockType: 'BUTTON', label: 'Button'},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	}));

	useEffect(() => {
		blocksManager.setIsDraggingBlock(isDragging); // Or isBlockDragging
	}, [isDragging]);
	
	return (
		<div
			ref={drag}
			className={`flex flex-col items-center p-3 border border-gray-200 rounded cursor-pointer hover:bg-gray-50 hover:border-blue-300 transition-colors ${
				isDragging ? 'opacity-50' : ''
			}`}
		>
			<RectangleHorizontal size={24} className="text-gray-600 mb-2" />
			<span className="text-xs text-center text-gray-700">Button</span>
		</div>
	);
}

export function DraggableDivider() {
	const [{isDragging}, drag] = useDrag(() => ({
		type: 'CONTENT_BLOCKS',
		item: {blockType: 'DIVIDER', label: 'Divider'},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	}));

	useEffect(() => {
		blocksManager.setIsDraggingBlock(isDragging); // Or isBlockDragging
	}, [isDragging]);
	
	return (
		<div
			ref={drag}
			className={`flex flex-col items-center p-3 border border-gray-200 rounded cursor-pointer hover:bg-gray-50 hover:border-blue-300 transition-colors ${
				isDragging ? 'opacity-50' : ''
			}`}
		>
			<Minus size={24} className="text-gray-600 mb-2" />
			<span className="text-xs text-center text-gray-700">Divider</span>
		</div>
	);
}

export function DraggableHeading() {
	const [{isDragging}, drag] = useDrag(() => ({
		type: 'CONTENT_BLOCKS',
		item: {blockType: 'HEADING', label: 'Heading'},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	}));

	useEffect(() => {
		blocksManager.setIsDraggingBlock(isDragging); // Or isBlockDragging
	}, [isDragging]);
	
	return (
		<div
			ref={drag}
			className={`flex flex-col items-center p-3 border border-gray-200 rounded cursor-pointer hover:bg-gray-50 hover:border-blue-300 transition-colors ${
				isDragging ? 'opacity-50' : ''
			}`}
		>
			<Heading1 size={24} className="text-gray-600 mb-2"/>
			<span className="text-xs text-center text-gray-700">Heading</span>
		</div>
	);
}

export function DraggableText() {
	const [{isDragging}, drag] = useDrag(() => ({
		type: 'CONTENT_BLOCKS',
		item: {blockType: 'TEXT', label: 'Text'},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	}));

	useEffect(() => {
		blocksManager.setIsDraggingBlock(isDragging); // Or isBlockDragging
	}, [isDragging]);
	
	return (
		<div
			ref={drag}
			className={`flex flex-col items-center p-3 border border-gray-200 rounded cursor-pointer hover:bg-gray-50 hover:border-blue-300 transition-colors ${
				isDragging ? 'opacity-50' : ''
			}`}
		>
			<Type size={24} className="text-gray-600 mb-2" />
			<span className="text-xs text-center text-gray-700">Text</span>
		</div>
	);
}

export function DraggableImage() {
	const [{isDragging}, drag] = useDrag(() => ({
		type: 'CONTENT_BLOCKS',
		item: {blockType: 'IMAGE', label: 'Image'},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	}));

	useEffect(() => {
		blocksManager.setIsDraggingBlock(isDragging); // Or isBlockDragging
	}, [isDragging]);
	
	return (
		<div
			ref={drag}
			className={`flex flex-col items-center p-3 border border-gray-200 rounded cursor-pointer hover:bg-gray-50 hover:border-blue-300 transition-colors ${
				isDragging ? 'opacity-50' : ''
			}`}
		>
			<Image size={24} className="text-gray-600 mb-2" />
			<span className="text-xs text-center text-gray-700">Image</span>
		</div>
	);
}

export function DraggableHeroSlider() {
	const [{isDragging}, drag] = useDrag(() => ({
		type: 'CONTENT_BLOCKS',
		item: {blockType: 'HERO_SLIDER', label: 'Carousel'},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	}));

	useEffect(() => {
		blocksManager.setIsDraggingBlock(isDragging); // Or isBlockDragging
	}, [isDragging]);
	
	return (
		<div
			ref={drag}
			className={`flex flex-col items-center p-3 border border-gray-200 rounded cursor-pointer hover:bg-gray-50 hover:border-blue-300 transition-colors ${
				isDragging ? 'opacity-50' : ''
			}`}
		>
			<Images size={24} className="text-gray-600 mb-2" />
			<span className="text-xs text-center text-gray-700">Carousel</span>
		</div>
	);
}

export function DraggableVideo() {
	const [{isDragging}, drag] = useDrag(() => ({
		type: 'CONTENT_BLOCKS',
		item: {blockType: 'VIDEO', label: 'Video'},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	}));

	useEffect(() => {
		blocksManager.setIsDraggingBlock(isDragging); // Or isBlockDragging
	}, [isDragging]);
	
	return (
		<div
			ref={drag}
			className={`flex flex-col items-center p-3 border border-gray-200 rounded cursor-pointer hover:bg-gray-50 hover:border-blue-300 transition-colors ${
				isDragging ? 'opacity-50' : ''
			}`}
		>
			<Play size={24} className="text-gray-600 mb-2" />
			<span className="text-xs text-center text-gray-700">Video</span>
		</div>
	);
}

export function DraggableSocials() {
	const [{isDragging}, drag] = useDrag(() => ({
		type: 'CONTENT_BLOCKS',
		item: {blockType: 'SOCIALS', label: 'Social'},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	}));

	useEffect(() => {
		blocksManager.setIsDraggingBlock(isDragging); // Or isBlockDragging
	}, [isDragging]);
	
	return (
		<div
			ref={drag}
			className={`flex flex-col items-center p-3 border border-gray-200 rounded cursor-pointer hover:bg-gray-50 hover:border-blue-300 transition-colors ${
				isDragging ? 'opacity-50' : ''
			}`}
		>
			<Share2 size={24} className="text-gray-600 mb-2" />
			<span className="text-xs text-center text-gray-700">Socials</span>
		</div>
	);
}

export function DraggableHtml() {
	const [{isDragging}, drag] = useDrag(() => ({
		type: 'CONTENT_BLOCKS',
		item: {blockType: 'HTML', label: 'Html'},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	}));

	useEffect(() => {
		blocksManager.setIsDraggingBlock(isDragging); // Or isBlockDragging
	}, [isDragging]);
	
	return (
		<div
			ref={drag}
			className={`flex flex-col items-center p-3 border border-gray-200 rounded cursor-pointer hover:bg-gray-50 hover:border-blue-300 transition-colors ${
				isDragging ? 'opacity-50' : ''
			}`}
		>
			<Code size={24} className="text-gray-600 mb-2" />
			<span className="text-xs text-center text-gray-700">HTML</span>
		</div>
	);
}